<template>
	<div grey-back full-height v-scroll="onScroll">

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">
		    	Opening Stock
		    	<div toolbar-subtitle v-show="offsetTop>48">{{Form.itemName}}</div>
		    </v-toolbar-title>

		    <!-- <v-spacer></v-spacer> -->

		    <!-- <v-btn round-borders outline @click="fn_checkValidations" :disabled="disableBtn">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>


		<v-form class="form-element hasToolbar hasBigFooterWithExtentionPlus grey-back" id="form">

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<!-- <v-alert :value="true" type="info" icon="info" transition="slide-y-transition" v-if="Form.maxOpeningDate">
				<span>This opening date will set as default for all opening ledgers or opening stock you will add later.</span>
			</v-alert> -->
			<v-subheader class="mb-2" white-background>Opening Date
				<v-spacer></v-spacer>
				<!-- <span medium-theme-color @click="fn_changeOpeningDate"><u>{{$root.CurrentBusiness.OpeningDate | moment("DD-MMM-YYYY")}}</u></span> -->
				<span medium-theme-color>{{$root.CurrentBusiness.OpeningDate | moment("DD-MMM-YYYY")}}</span>
			</v-subheader>

			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 align-msg-right form-item
		        	@click="fn_openProductsDialog">

	               <v-text-field  
		               	readonly
		               	v-model="Form.itemName" 
		               	:hide-details="Form.summaryArray.length ? true : false"
		               	label="Item" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	:onUpdate="fn_updateProduct"
		               	ref="ref_fieldProductName"
		               	v-validate="'required'" 
	               		data-vv-name="item" 
	               		:error-messages="errors.collect('item')"
	               		required>
	               </v-text-field>

	               <div custom-message>
	               		<span v-for="(item, index) in Form.summaryArray" v-if="Form.summaryArray.length">
	               			{{item.unitName}}: <span :class="[item.qty < 0 ? 'redcolor' : 'greencolor']">{{item.roundOffQty}}</span>
	               			<!-- {{item.unitName}}<span v-if="item.packQuantity != 0 && item.packQuantity != null">({{item.packQuantity}})</span>: 
	               			<b>{{item.qty}}</b>{{Form.summaryArray.length-1 != index ? ',&nbsp;' : ''}} -->
	               		</span>
	               </div>
	            </v-flex>
	           

	           <!--  <span v-for="(item, index) in Form.summaryArray" v-if="Form.summaryArray.length">
	            	{{item.unitName}} {{item.qty ? item.qty : 0}}
	            	{{Form.summaryArray.length-1 != index ? ', ' : ''}}
	            </span> -->

			</v-layout>

			<div v-for="(transactionItem, tIndex) in Form.trProducts" :key="tIndex" :id="'section'+tIndex" :class="transactionItem.groupId" margin-top-ten>

				<!-- <v-subheader subheader-dense white-background norightpadding>
					#{{tIndex+1}}
					<v-spacer></v-spacer>
					<v-menu v-if="Form.trProducts.length > 1">

				      <v-btn slot="activator" icon>
				      	<v-icon>more_horiz</v-icon>
				      </v-btn>

				      <v-list nopadding>
				        <v-list-tile @click="fn_removeItem(tIndex, transactionItem.variants)">
				        	<v-list-tile-title>Remove</v-list-tile-title>
				        </v-list-tile>
				      </v-list>

				    </v-menu>
				</v-subheader>

				<v-divider></v-divider> -->

				<v-layout wrap white-background padding-top-bottom-ten>

					<v-layout row wrap form-item grey-back v-if="transactionItem.variants && transactionItem.variants.length > 1">
					  <v-subheader nopadding subheader-dense>Quantity</v-subheader>
					</v-layout>
				  	

		        	<!-- <v-layout row wrap v-for="(item, vIndex) in transactionItem.variants" :key="vIndex"> -->
					<v-layout row wrap>
			        	 <v-flex xs6 sm6 md6 align-msg-right form-item v-for="(item, vIndex) in transactionItem.variants" :key="vIndex">
				           	<!-- <v-text-field 
				           		@focus="fn_focusItem"
				           		v-model.number="item.qty"
				           		:label="item.label" 
				           		:hint="'&#8377; '+ $root.numberToLocale(item.amount)"
				           		persistent-hint
				           		placeholder=" "
				           		type="number"
				           		v-validate="'numeric|max:8'" 
			               		:data-vv-name="item.label+tIndex" 
			               		data-vv-as="quantity"
			               		:error-messages="errors.collect(item.label+tIndex)">
				           	</v-text-field> -->
							<!-- :label="'Quantity ('+ item.label + ')'"  -->
							<v-text-field 
				           		@focus="fn_focusItem"
								@input="$root.fn_boundDecimalLength(item, null, 'qty')"
				           		v-model="item.qty"
				           		label="Quantity" 
				           		:hint="'&#8377; '+ $root.numberToLocale(item.amount)"
				           		persistent-hint
				           		placeholder=" "
				           		type="number">
				           	</v-text-field>
				        </v-flex>

						<template v-if="Form.selectedItemData && Form.selectedItemData.productVariants && Form.selectedItemData.productVariants.length">
							<v-flex xs6 sm6 md6 pr-3 pl-2 v-for="(item, vIndex) in Form.selectedItemData.productVariants" :key="vIndex" v-if="Form.selectedItemData">
								<v-text-field 
									v-if="!item.secondaryUnitId"
									:disabled="true"
									:value="item.unitName"
									label="Unit"
									placeholder=" ">
								</v-text-field>

								<v-select
									v-else
									:items="[{itemId:item.unitId, itemName:item.unitName}, {itemId:item.secondaryUnitId, itemName:item.secondaryUnitName}]"
									label="Unit"
									item-text="itemName"
									item-value="itemId"
									v-model="Form.selectedUnit"
									:hide-details="true"
									return-object
									ref="ref_unitSelection"
									@change="fn_unitChange($event, item, transactionItem)"
								></v-select>

								<div class="pb-3 pt-1 right-align" v-if="item.secondaryUnitId">{{ item.packQuantity }} {{ item.unitName }} = {{ item.secondaryUnitPackQuantity }} {{ item.secondaryUnitName }}</div>
							</v-flex>
						</template>

					<!-- <span v-if="Form.selectedItemData && Form.selectedItemData.productVariants && Form.selectedItemData.productVariants.length">{{ Form.selectedItemData.productVariants }}</span> -->
			        </v-layout>

					<v-layout row wrap>

						<!-- <v-flex xs6 sm6 md6 pr-2 pl-3 v-if="$root.TransactionSettings.mrpWiseStock">
							<v-text-field 
								@focus="fn_focusItem"
								v-model.number="transactionItem.mrp"
								prefix="₹"
								label="MRP" 
								placeholder=" "
								type="number"
								v-validate="'min_value:0|decimal:2'" 
								data-vv-name="mrp" 
								:error-messages="errors.collect('mrp')">
							</v-text-field>
						</v-flex> -->

						<!-- <v-flex xs6 sm6 md6 pr-3 pl-2 :class="[!$root.TransactionSettings.mrpWiseStock ? 'xs12 sm12 md12 pr-3 pl-3' : 'xs6 sm6 md6 pr-3 pl-2']"> -->
						<v-flex xs12 sm12 md12 form-item v-if="Form.selectedItemData && Form.selectedItemData.productVariants && Form.selectedItemData.productVariants.length">
							<v-text-field 
								prefix="₹"
								@focus="fn_focusItem"
								v-model.number="transactionItem.rate"
								:label="Form.selectedItemData.productVariants[0].secondaryUnitId ? 'Rate (Per ' + Form.selectedUnit.itemName + ')' : 'Rate (Per ' + Form.selectedItemData.productVariants[0].unitName + ')'"
								placeholder=" "
								type="number"
								v-validate="'min_value:0|decimal:4'" 
								data-vv-name="rate" 
								:error-messages="errors.collect('rate')">
							</v-text-field>
						</v-flex>
						
						</v-layout>
			        
				</v-layout>

				<div class="pt-2 grey-back full-width" v-if="$root.TransactionSettings.enableBatch">
					<template v-if="hasSeries && !hasOnlySeries">
						<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="Form.selectedBatchType" row>
							<v-radio label="Batch" :value="1"></v-radio>
							<v-radio label="Series" :value="2"></v-radio>
						</v-radio-group>
						<v-divider></v-divider>
					</template>

					<!-- <v-card flat v-for="(batch, batchIndex) in transactionItem.batches" :key="batchIndex">
						<v-divider></v-divider>
						<v-card-text class="pb-2">
							<v-layout row wrap>
								<v-flex xs2 sm2 md2 mb-2>
									<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
									<div light-opacity-color>Batch No.</div>
									<div>{{ batch.batchNumber }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
									<div light-opacity-color>Size</div>
									<div>{{ batch.batchSize }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
									<div light-opacity-color>MRP</div>
									<div>{{ batch.batchMRP }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
									<div light-opacity-color>Mfg. Date</div>
									<div v-if="batch.mfgDate">{{ batch.mfgDate | moment('DD-MMM-YYYY') }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
									<div light-opacity-color>Exp. Date</div>
									<div v-if="batch.expDate">{{ batch.expDate | moment('DD-MMM-YYYY') }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
									<div light-opacity-color>Purchase Rate</div>
									<div>{{ batch.purchaseRate }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
									<div light-opacity-color>Serial Number</div>
									<div>{{ batch.field1 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
									<div light-opacity-color>IMEI Number</div>
									<div>{{ batch.field2 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
									<div light-opacity-color>Part Number</div>
									<div>{{ batch.field3 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
									<div light-opacity-color>Model Number</div>
									<div>{{ batch.field4 }}</div>
								</v-flex>
							</v-layout>

							<v-layout row wrap>
								<v-flex xs4 sm4 md4 pr-2 :class="{'error_background':batch.currentStock<0}">
									<v-text-field
										readonly
										:error="batch.currentStock<0"
										label="Stock"
										:value="batch.currentStock ? batch.currentStock : 0"
										placeholder=" "
									></v-text-field>
								</v-flex>

								<v-flex xs8 sm8 md8 pl-2>
									<v-text-field
										label="Quantity"
										v-model.number="batch.productQty"
										@input="fn_changeBatchQty"
										type="number"
										placeholder=" "
									></v-text-field>
								</v-flex>
							</v-layout>
						</v-card-text>
					</v-card> -->
				</div>
			</div>

			<template v-if="$root.TransactionSettings.enableBatch">
				<v-subheader class="white-background" v-if="$root.TransactionSettings.enableBatch && Form.trProducts && Form.trProducts.length">
					<template v-if="Form.selectedBatchType == 2"><span v-for="(field, index) in $root.TransactionSettings.batchFields" :key="field.title" v-if="field.id == 'field1' || field.id == 'field2' || field.id == 'field3'">{{ field.title }}<span v-if="$root.TransactionSettings.batchFields.length - 1 != index">/</span></span></template>
					<template v-else>Batches</template>
					<v-spacer></v-spacer> 
					<v-btn small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="fn_openDialogSelectBatch(transactionItem, tIndex)">
						<v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
					</v-btn>
				</v-subheader>

				<template v-for="(batch, batchIndex) in Form.batches">
					<v-card flat :key="batchIndex" v-if="batch.opening">
						<v-card-text class="pb-2">
							<v-layout class="batch_layout" row wrap>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
									<div light-opacity-color>Batch No.</div>
									<div>{{ batch.batchNumber }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
									<div light-opacity-color>Size</div>
									<div>{{ batch.batchSize }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
									<div light-opacity-color>MRP</div>
									<div>{{ batch.batchMRP }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
									<div light-opacity-color>Mfg. Date</div>
									<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
									<div light-opacity-color>Exp. Date</div>
									<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.opening && !batch.field1 && !batch.field2 && !batch.field3">
									<div light-opacity-color>Opening</div>
									<div>{{ batch.opening ? batch.opening : 0  }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
									<div light-opacity-color>Purchase Rate</div>
									<div>{{ batch.purchaseRate }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
									<div light-opacity-color>Serial Number</div>
									<div>{{ batch.field1 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
									<div light-opacity-color>IMEI Number</div>
									<div>{{ batch.field2 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
									<div light-opacity-color>Part Number</div>
									<div>{{ batch.field3 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
									<div light-opacity-color>Model Number</div>
									<div>{{ batch.field4 }}</div>
								</v-flex>
								<v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && fn_checkDate(batch)">
									<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ fn_getDate(batch) }}
								</v-flex>
								<!-- <v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.productVariants[0].qty)">
									<div light-opacity-color>Quantity</div>
									<div>{{ batch.productQty }}</div>
								</v-flex> -->
							</v-layout>
							<!-- <v-layout row wrap>
								<v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="batch[field.id]">
									<div light-opacity-color>{{ field.title }}</div>
									<div v-if="field.type == 'date'">{{ batch[field.id] | moment('DD-MMM-YYYY') }}</div>
									<div v-else>{{ batch[field.id] }}</div>
								</v-flex>
							</v-layout> -->
						</v-card-text>
						<v-card-actions class="pa-0 ma-0" v-if="batch.isNew">
							<v-spacer></v-spacer>
							<v-btn color="red" capitalize flat small @click="fn_removeBatch(batchIndex)">Remove</v-btn>
						</v-card-actions>
					</v-card>
					<v-divider v-if="Form.batches.length - 1 != batchIndex"></v-divider>
				</template>
			</template>
			

			<!-- <v-layout grey-back row wrap white-background v-if="Form.trProducts.length">
				<v-flex xs12 sm12 md12 right-align>
			    	<v-btn light-opacity-color class="ma-3" capitalize outline @click="fn_addMore">Add More</v-btn>
			  	</v-flex>
			</v-layout> -->

			<v-layout wrap white-background mt-2 v-if="Form.trProducts.length">
				<v-list full-width nopadding>
				  	<v-list-tile>

				  		<v-list-tile-action v-if="Form.transactionData.notes">
			            	<v-btn icon @click="Form.transactionData.notes = ''">
					  			<v-icon>close</v-icon>
					  		</v-btn>
			            </v-list-tile-action>

			          	<v-list-tile-content full-width @click="fn_addNote">
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
						  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
			            </v-list-tile-content>
						
				    </v-list-tile>
				</v-list>

				<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
					<v-divider></v-divider>
				  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</v-layout>

			<!-- <v-layout wrap margin-top-ten white-background>
				<v-list full-width nopadding>
				  	<v-list-tile border-bottom-thin>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
            					{{Form.transactionData.notes ? 'Edit' : 'Add'}}
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>	

				<v-card flat class="note-card" v-if="Form.transactionData.notes">
				  <v-card-text v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</v-layout> -->

			<!-- <div id="note" v-if="Form.transactionData.notes" class="margin-top-ten">
				<v-list full-width nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
            					Edit
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-divider></v-divider>

				<v-card flat class="note-card">
				  <v-card-text v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
				</v-card>
			</div> -->

		</v-form>

		<!-- <v-footer class="pa-3" fixed dark-grey style="border-top:0.5px #F0F0F0 solid">
	    	<v-layout row wrap>
	    	  <v-flex xs4 style="text-align:left">Total Amount</v-flex>
	    	  <v-flex xs8 style="text-align:right">&#8377; {{totalAmount ? $root.numberToLocale(totalAmount) : totalAmount}}</v-flex>
	    	</v-layout>
	    </v-footer> -->

	    <div white-background full-width nopadding style="position:fixed;bottom:0;">
			<v-layout row wrap>
				<template v-if="totalAmount">
					<template v-if="batchTotalQty">
						<v-flex xs6 sm6 md6 pl-3 pt-2 pb-1 style="text-align:left">Batch Total Opening</v-flex>
						<!-- Form.trProducts[0].variants[0].label -->
	    	  			<v-flex xs6 sm6 md6 pr-3 pt-2 pb-1 style="text-align:right">{{batchTotalQty}} {{Form.selectedUnit ? Form.selectedUnit.itemName : Form.trProducts[0].variants[0].unitName }}</v-flex>
					</template>
					<v-flex xs4 sm4 md4 pl-3 pb-2 style="text-align:left">Total Amount</v-flex>
	    	  		<v-flex xs8 sm8 md8 pr-3 pb-2 style="text-align:right">&#8377; {{totalAmount ? $root.numberToLocale(totalAmount) : totalAmount}}</v-flex>
				</template>
				<v-flex xs12 sm12 md12 height48>
					<v-btn color="primary" full-height nomargin block no-round-borders :disabled="disableBtn" noshadow @click="fn_checkValidations">Save</v-btn>
				</v-flex>
			</v-layout>
		</div>

	    <v-dialog v-model="loading" no-click-animation no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <dialog-note ref="ref_dialogNote"></dialog-note>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
		<dialog-products ref="ref_dialogProductList" :setNewProduct="this.fn_setProduct" :newProduct="fn_menuItemClick" :closeDialog="fn_closeDialog"></dialog-products>

	    <!-- <dialog-datepicker-opening ref="ref_dialogDatePickerOpening" :selected="openingDate" :updateDate="fn_updateDateOpening" :minDate="minDate" :maxDate="maxOpeningDate"></dialog-datepicker-opening> -->

	    <!-- <dialog-confirmation ref="ref_dialogConfirmation" header="Set Opening Date?" :actionMethod="fn_changeOpeningDate"></dialog-confirmation> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	    <!-- <dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_gotoSetupDrive"></dialog-drive-alert> -->
		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>
		<dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.itemId" :productData="Form.productData" :openDatePicker="fn_openDatePicker" :openingForm="true" :selectedUnit="Form.selectedUnit"></dialog-select-batch>
		<dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker-batch>

	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;
const productGroupTypeId = require('../../../../config.js').configs.productGroupTypeId;
const transactionData = require('../../datamodel').data.transactionData;

import dialogNote from '../dialogs/dialog_note'
import dialogDiscard from '../../../dialogs/dialog_discard'
import dialogProducts from '../../../dialogs/dialog_products'
// import dialogDatePickerOpening from '../dialogs/dialog_datepicker_opening'
import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'
// import dialogConfirmation from '../../../dialogs/dialog_confirmation'

// import dialogDriveAlert from '../dialogs/dialog_drive_alert'
import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'

import dialogSelectBatch from '../dialogs/dialog_select_batch'
import dialogDatepickerBatch from '../../../dialogs/dialog_datepicker_batch'
import Form from '../purchase/form.vue';

const transactionTypes = require('../../../../config.js').configs.transactionTypes;

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		data(){
			return{

				Form:{
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
					"transactionProducts":[],
					"trProducts":[],

					"productRefId":null,
					"itemName":null,
					"itemId":null,

					// "deletedTransactionProductIds":[],
					"summary":'',
					"summaryArray":[],
					"isNew":true,
					"batches":[],
					"selectedBatchType":null,
					"productData":null,
					"selectedItemData":null,
					"selectedUnit":null
					// "maxOpeningDate":null,
					// "openingDate":null,
					// "minDate":null
				},

				transactionProductModel:{transactionProductId:null, transactionId:null, productId :null, productVariantId:null, transactionProductMode:1, mrp:null, rate:null, taxableValue:null, additionalData:{}, groupId:this.guid(), variants:[]},

				variantObj:{label:null, unitId:null, unitName:null, packQuantity:null, qty:null, amount:null, productId:null, productVariantId:null},


				loading:false,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,

				// loadedFromDraft:false,

				showFooter:true,
				offsetTop:0,

				// maxOpeningDate:null,
				// openingDate:null,
				// minDate:null,
				disableBtn:false,
				hasSeries:false,
				hasOnlySeries:true,
				selectedDate:null,
				dateType:null,
				dialog_datepicker:false,
				// tempRate:null
			}
		},
		components:{
			'dialog-note':dialogNote,
			'dialog-discard': dialogDiscard,
			'dialog-products':dialogProducts,
			'dialog-drive-alert':dialogDriveAlert,
			'dialog-select-batch':dialogSelectBatch,
			'dialog-datepicker-batch':dialogDatepickerBatch
			// 'dialog-datepicker-opening':dialogDatePickerOpening,
			// 'dialog-confirmation':dialogConfirmation
			// 'dialog-drive-alert':dialogDriveAlert
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.itemName);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			// fn_openConfirmationDialog: function () {
			// 	this.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogConfirmation');
			// },

			// fn_openDatePickerOpening: function () {
			// 	this.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerOpening');
			// },

			// fn_updateDateOpening: function(value){
			// 	this.Form.openingDate = value;
			// 	console.log(this.Form.openingDate);
			// 	this.fn_closeDialog();
			// },

			fn_focusItem: function (event) {
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo(event.target, self.scrollOptions);
				},300);
			},

			onScroll: function (e) {
				this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
			},

			fn_removeItem: function (tIndex, variants) {
				// if(this.Form.transactionData.transactionId){
				// 	for(let i=0;i<variants.length;i++){
				// 		let obj = {};
				// 		obj.transactionProductId = variants[i].transactionProductId;
				// 		this.Form.deletedTransactionProductIds.push(obj);
				// 	}
				// }
				this.Form.trProducts.splice(tIndex, 1);
			},

			fn_openProductsDialog: function () {
				//force save to local storage
				// this.fn_saveDraft(this.Form.itemName);
				this.fn_openProductList('android', 'ProductList', 'ref_fieldProductName');
			},

			// fn_openProductsDialog: function () {
			// 	let viewDialogObject = {
			// 		ToolbarTitle:"Item", 
			// 		action:"new",
			// 		groupTypeId:productGroupTypeId.product,
			// 		inventory:1,
			// 		selectedItem:{itemId:this.Form.itemId, itemName:this.Form.itemName}
			// 	};

			// 	localStorage.setItem("dialog_properties", JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Products', 'ref_dialogProductList');
			// 	// this.fn_openProductList('android', 'ProductList', 'ref_fieldProductName');
			// },

			fn_openProductList: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				viewDialogObject.groupTypeId = productGroupTypeId.product;
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.inventory = 1;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.itemId && this.Form.itemName){
					paramObject.defaultValue = {"id":this.Form.itemId, "name":this.Form.itemName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
			},

			// fn_updateProduct: function (selectedValueId, selectedValueName, isRemoved) {
			// 	if(!isRemoved){
			// 		this.Form.itemId = selectedValueId;
		    //     	this.Form.itemName = selectedValueName;
		    //     	this.errors.remove('item');
		    //     	this.fn_getData('TransactionProductsOfProduct', selectedValueId);
			// 	}
			// 	else{
			// 		this.Form.itemId = null;
		    //     	this.Form.itemName = null;
		    //     	this.Form.productRefId = null;
		    //     	this.Form.summaryArray = [];
		    //     	// this.fn_clearForm(this.Form.openingDate, this.Form.maxOpeningDate, this.Form.minDate);
		    //     	this.fn_clearForm();
			// 	}
			// 	this.$forceUpdate();
			// },
			fn_setProduct: function(id, name){
				this.fn_closeDialog();
				this.fn_updateProduct(id, name);
			},

			fn_updateProduct: function (id, name) {
				this.selectedItem = {itemId:id, itemName:name};
				this.Form.itemId = id;
				this.Form.itemName = name;
				this.fn_getBatches(id);
				this.fn_getData('TransactionProductsOfProduct', id);
				this.$forceUpdate();
			},

			fn_itemTotal: function (item, rate) {
				let packQty = 1;

				// item.packQuantity ? packQty = item.packQuantity : '';

				if(!item.qty || !rate)
					item.amount = 0;
				else{
					let amount = item.qty * packQty * rate;
					item.amount = this.roundUpto2Decimals(amount);
				}
			},

			fn_addMore: function () {
				this.transactionProductModel.groupId = this.guid();
				let item = JSON.parse(JSON.stringify(this.transactionProductModel));
				this.Form.trProducts.push(item);
			},

			fn_clearModel: function () {
				this.transactionProductModel = {"transactionProductId":null, "transactionId":null, "productId" :null, "productVariantId":null, "mrp":null, "rate":null, "taxableValue":null, "additionalData":{}, "variants":[]};
			},

			fn_getProductData: function (itemId, refreshUnits) {
				var self = this;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);

				          	// let productData = JSON.parse(response);

							self.Form.productData = JSON.parse(response);

				          	if(refreshUnits){
				          		self.fn_refreshUnits(self.Form.productData.productVariants);
				          	}
				          	else{
				          		self.Form.productRefId = self.Form.productData.productId;
					          	self.fn_bindProduct(self.Form.productData);
				          	}

				          	self.fn_getSummary(itemId);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},


			fn_refreshUnits: function (productVariants) {

				let self = this;

				//adding/updating default variants values
				this.fn_pushVariants(productVariants);

				if(productVariants.length > this.Form.summaryArray.length){
					this.fn_refreshSummary(productVariants);
				}

				let trp = this.Form.trProducts;

				let variantsToAdd = [];

				for(let i=0; i<trp.length; i++){

					let variants = JSON.parse(JSON.stringify(trp[i].variants));

					if(variants.length != productVariants.length){

						for(var j in productVariants){
						   	var shared = false;

						   	for (var k in variants){
						   		if (variants[k].productVariantId == productVariants[j].productVariantId) {
						           shared = true;
						           break;
						       }
						   	}
						       
						   	if(!shared){
						   		let variantObj = {};

					          	let uName = productVariants[j].unitName;
					          	let pQty = productVariants[j].packQuantity

					          	variantObj.unitName = productVariants[j].unitName;
					          	variantObj.unitId = productVariants[j].unitId;
					          	variantObj.primaryUnitId = productVariants[i].variantBaseUnitId;
					          	variantObj.packQuantity = productVariants[j].packQuantity;
					          	variantObj.productId = productVariants[j].productId;
					          	variantObj.productVariantId = productVariants[j].productVariantId;

					          	variantObj.qty = null;
					          	variantObj.amount = null;

					          	this.fn_getLabel(uName, pQty, function (label) {
					          		variantObj.label = label;
					          		trp[i].variants.splice(j, 0, variantObj);
					          	});
						   	} 
						}

					}
				}

			},

			fn_getSelectedItemData: function (itemId, data) {
				var self = this;
				this.Form.selectedUnit = null;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
							self.Form.selectedItemData = JSON.parse(response);

							if(data && data.transactionProducts && data.transactionProducts.length && data.transactionProducts[0].variants && data.transactionProducts[0].variants.length){
								self.Form.selectedUnit = {};
								self.Form.selectedUnit.itemId = data.transactionProducts[0].variants[0].unitId;
								self.Form.selectedUnit.itemName = data.transactionProducts[0].variants[0].unitName;
							}
							else if(self.Form.selectedItemData.productVariants[0].secondaryUnitId){
								self.Form.selectedUnit = {};
								self.Form.selectedUnit.itemId = self.Form.selectedItemData.productVariants[0].unitId;
								self.Form.selectedUnit.itemName = self.Form.selectedItemData.productVariants[0].unitName;
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_refreshSummary: function (productVariants) {

				var summaryArray = JSON.parse(JSON.stringify(this.Form.summaryArray));

				for(var i in productVariants){
				   	var shared = false;
				   	for (var j in summaryArray){
				   		if (summaryArray[j].unitId == productVariants[i].unitId) {
				           shared = true;
				           break;
				       	}
				  	}
				   	if(!shared){
				   		let obj = {};
						obj.unitId = productVariants[i].unitId;
						obj.unitName = productVariants[i].unitName;
						obj.qty = 0;
						this.Form.summaryArray.splice(i, 0, obj);
				   	} 
				}

			},

			fn_bindProduct: function (productData) {
				this.Form.trProducts = [];
				this.transactionProductModel.variants = [];
	          	
	          	let mrp = null;
	          	let self = this;

	          	//adding/updating default variants values
	          	this.fn_pushVariants(productData.productVariants, function (mrp) {
	          		let item = JSON.parse(JSON.stringify(self.transactionProductModel));
					self.Form.trProducts.push(item);
	          	});

	          	self.Form.trProducts[0].mrp = productData.mrp;

	          	productData.productVariants.filter(item=>{
	          		let obj = {};
	          		obj.unitId = item.unitId;
	          		obj.unitName = item.unitName;
	          		obj.qty = 0;
	          		self.Form.summaryArray.push(obj);
	          	})
			},

			fn_pushVariants: function (variants, callback) {
				let mrp = null;
				this.transactionProductModel.variants = [];

				let self = this;
				for(let i=0;i<variants.length;i++){

		          	let variantObj = {};

		          	variants[i].isDefault ? mrp = variants[i].mrp : '';

		          	let uName = variants[i].unitName;
		          	let pQty = variants[i].packQuantity;

		          	this.fn_getLabel(uName, pQty, function (label) {

		          		variantObj.label = label;

		          		variantObj.unitName = variants[i].unitName;
			          	variantObj.unitId = variants[i].unitId;
			          	variantObj.primaryUnitId = variants[i].variantBaseUnitId;
			          	variantObj.packQuantity = variants[i].packQuantity;
			          	variantObj.productId = variants[i].productId;
			          	variantObj.productVariantId = variants[i].productVariantId;

			          	variantObj.qty = null;
			          	variantObj.amount = null;

			          	self.transactionProductModel.variants.push(variantObj);

		          	});

		          	// variantObj.unitName = variants[i].unitName;
		          	// variantObj.unitId = variants[i].unitId;
		          	// variantObj.primaryUnitId = variants[i].variantBaseUnitId;
		          	// variantObj.packQuantity = variants[i].packQuantity;
		          	// variantObj.productId = variants[i].productId;
		          	// variantObj.productVariantId = variants[i].productVariantId;

		          	// variantObj.qty = null;
		          	// variantObj.amount = null;

		          	// this.transactionProductModel.variants.push(variantObj);
		        }

		        if(callback!=undefined){
					callback(mrp);
		        }
			},

			fn_getLabel: function (uName, pQty, cb) {
				let label = null
				if(pQty){
	          		label = uName + ' ('+pQty+')';
	          	}
	          	else{
	          		label = uName;
	          	}

	          	cb(label);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialogWeb: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	let bottomMenu = null;

			// 	let menuItem_Note = null;
			// 	!this.Form.transactionData.notes ? menuItem_Note = menuItem.addNote : menuItem_Note = menuItem.editNote;

			// 	bottomMenu = {"BottomMenu": [menuItem.save, menuItem_Note,  menuItem.reset, menuItem.help]};

			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				this.disableBtn = true;
				let quantityFilled = false;
				this.showLoading('Please wait...');
				this.$validator.validateAll().then((result) => {
			        if (result) {
						let totalQty = 0;
			           	for(let i=0;i<this.Form.trProducts.length;i++){
					
							this.Form.trProducts[i].quantityFilled = false;

							let tP = this.Form.trProducts[i];
			    			for(let j=0;j<tP.variants.length;j++){
								totalQty = totalQty + Number(tP.variants[j].qty);
			    				if(tP.variants[j].qty){
			    					quantityFilled = true;
			    					this.Form.trProducts[i].quantityFilled = true;
			    				}
			    			}

			    		}

						if(this.$root.TransactionSettings.enableBatch && totalQty && this.Form.batches && this.Form.batches.length){
							let batchTotal = 0;
							for(let i=0; i<this.Form.batches.length; i++){
								batchTotal += this.Form.batches[i].opening;
							}

							let openingQty = this.Form.trProducts[0].variants[0].qty ? this.Form.trProducts[0].variants[0].qty : 0; 
							if(openingQty != batchTotal){
								this.disableBtn = false;
								this.showToast("Opening quantity not matched with batch total opening");
								this.hideLoading();
								return;
							}
							// if(totalQty != batchTotal){
							// 	this.showToast("Opening quantity not matched with batch total opening");
							// 	this.disableBtn = false;
			    			// 	this.hideLoading();
							// 	return;
							// }
						}

			    		if(!quantityFilled){
			    			this.showToast('Please add quantity');
			    			this.disableBtn = false;
			    			this.hideLoading();
			    			return;
			    		}
			    		else{
			    			this.fn_post();
			    		}
			        }
			        else{
			        	this.hideLoading();
			        	this.disableBtn = false;
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('TransactionProducts', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	// self.fn_setMinTransactionDate();
				          	self.fn_cleanUp();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
							let response = JSON.parse(error);
							if(response && response.openingStockExistsError){
                                self.showToast("Opening already added.");
                            }
				        }
					}
		        );
			},

			fn_cleanUp: function () {
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.hideLoading();
					self.$router.go(-1);
				});
			},


			fn_post: function(){

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
					//random transaction number just for now
					// this.Form.transactionData.transactionNumber = 'TN/'+this.randomFourCharString();
					this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
				}

				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.amount = this.totalAmount;
				this.Form.transactionData.roundedAmount = Math.round(this.totalAmount);
				this.Form.transactionData.status = 1;
				this.Form.transactionData.refDate = null;

				//Calculation of opening ledger date
				// let currentDate = new Date();
				// let currentMonth = currentDate.getMonth() + 1;
				// let currentYear = currentDate.getFullYear();

				// let openingStockDate = null
				// openingStockDate = currentMonth > 3 ? currentYear : currentYear-1;

				// this.Form.transactionData.transactionDate = new Date(openingStockDate+"-03-31");

				// let od = new Date(JSON.parse(JSON.stringify(this.openingDate)));
				let od = new Date(JSON.parse(JSON.stringify(this.$root.CurrentBusiness.OpeningDate)));
	            od.setDate(od.getDate()-1);
				// this.Form.transactionData.transactionDate = new Date(od);
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(od);

				let postObj = {};

				postObj = this.Form.transactionData;
				postObj.transactionProductBatches = [];

				if(this.Form.batches.length){
					// postObj.masterProductBatches = this.Form.batches.filter(batch=>{return batch.isNew});
					postObj.masterProductBatches = this.Form.batches;
				}

				for(let i=0; i<this.Form.trProducts.length; i++){
					let tP = this.Form.trProducts[i];

					for(let j=0; j<tP.variants.length; j++){

						let variant = tP.variants[j];

						let tpObj = {};

						if(variant.qty){

							!variant.transactionProductId ? tpObj.transactionProductId = this.guid() : tpObj.transactionProductId = variant.transactionProductId;

							tpObj.transactionId = this.Form.transactionData.transactionId;

							tpObj.productId = variant.productId;

							tpObj.productVariantId = variant.productVariantId;

							tpObj.groupId = tP.groupId;

							// tpObj.mrp = tP.mrp ? tP.mrp : null;

							// tpObj.rate = tP.rate ? tP.rate : null;

							tpObj.mrp = tP.mrp ? tP.mrp : 0;

							tpObj.rate = tP.rate ? tP.rate : 0;

							tpObj.additionalData = null;

							// tpObj.unitId = variant.unitId;
							tpObj.unitId = this.Form.selectedUnit ? this.Form.selectedUnit.itemId : variant.unitId;

							tpObj.primaryUnitId = variant.primaryUnitId;

							if(this.Form.selectedItemData.productVariants[0].secondaryUnitId){
								tpObj.secondaryUnitId = this.Form.selectedItemData.productVariants[0].secondaryUnitId;
								tpObj.secondaryUnitPackQuantity = Number(this.Form.selectedItemData.productVariants[0].secondaryUnitPackQuantity);
							}

							tpObj.qty = variant.qty;

							tpObj.packQuantity = variant.packQuantity ? variant.packQuantity : 1;

							tpObj.transactionProductMode = 1;

							//saving actual quantity in positive and negative in inventory products in the form of qty
							tpObj.actualQty = variant.qty;

							if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != variant.primaryUnitId){
								tpObj.actualQty = this.roundUpto5Decimals((variant.qty * variant.packQuantity) / this.Form.selectedItemData.productVariants[0].secondaryUnitPackQuantity);
							}

							tpObj.amount = variant.amount;
							// net amount col post added on 12-mar-2026 just to	make it consistent with other transaction types,
							// before 12-mar-2026 we were using netAmount col for average rate calculation in opening stock transaction products, but now we are using amount col for average rate calculation as per discussion with backend team, so posting netAmount same as amount in opening stock transaction products
							// average rate is calculating thru amount col in opening stock transaction products as per discussion with backend team
							tpObj.netAmount = variant.amount;

							tpObj.taxableValue = variant.amount;

							for(let i=0; i<this.Form.batches.length; i++){
								this.Form.batches[i].isNew ? delete this.Form.batches[i].isNew : '';

								this.Form.batches[i].productId = variant.productId;

								let obj = {};
								obj.productId = variant.productId;
								obj.transactionProductBatchId = this.guid();
								obj.batchId = this.Form.batches[i].batchId;
								obj.transactionProductId = tpObj.transactionProductId;
								obj.qty = this.Form.batches[i].opening ? this.Form.batches[i].opening : 0;
								obj.orderNumber = i + 1;
								obj.transactionId = this.Form.transactionData.transactionId;
								obj.transactionListId = this.Form.transactionData.transactionListId;
								obj.actualQty = this.Form.batches[i].opening ? this.Form.batches[i].opening : 0;
								if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != variant.primaryUnitId){
									obj.actualQty = this.roundUpto5Decimals((obj.actualQty * variant.packQuantity) / this.Form.selectedItemData.productVariants[0].secondaryUnitPackQuantity);
								}
								postObj.transactionProductBatches.push(obj);
							}

							tpObj.selectedBatchType = this.Form.selectedBatchType;

							this.Form.transactionProducts.push(tpObj);

						}

					}

				}

				// postObj = this.Form.transactionData;
				postObj.transactionProducts = this.Form.transactionProducts;

				let currentAssetsAddOn = {};
				postObj.currentAssetsTransactions = [];
				currentAssetsAddOn.currentAssetsTransactionId = this.guid();
				// currentAssetsAddOn.transactionId = this.Form.transactionData.transactionId;
				// currentAssetsAddOn.value = this.Form.transactionData.roundedAmount;
				// currentAssetsAddOn.date = this.Form.transactionData.createdDate;
				// currentAssetsAddOn.transactionListId = this.Form.transactionData.transactionListId;
				postObj.currentAssetsTransactions.push(currentAssetsAddOn);
				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');
				// postObj.openingDate = this.Form.openingDate;
				console.log(this.Form);
				this.fn_saveLocal(postObj);
			},

			fn_getData: function (type, itemId) {
				this.Form.isNew = false;
				
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData(type, itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);

							let item = null;

							if(response){
								item = JSON.parse(response);
								self.fn_bindData(item);
							}
							else{
								// self.fn_clearForm(self.Form.openingDate, self.Form.maxOpeningDate, self.Form.minDate);
								self.fn_clearForm();
								type=='TransactionProductsOfProduct' ? self.fn_getProductData(itemId) : '';
							}

							let productId = type == 'TransactionProducts' ? item.productId : itemId;
							self.fn_getSelectedItemData(productId, item);

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getSummary: function (itemId) {
				var self = this;
				this.getData('ProductSummary', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let str = '';
							self.Form.summaryArray = JSON.parse(response);
							
							console.log(str);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function (item) {
				this.unwatch = true;
				this.Form.transactionData.amount = item.amount;
				this.Form.transactionData.createdDate = item.createdDate;
				this.Form.transactionData.modifiedDate = item.modifiedDate;
				this.Form.transactionData.roundedAmount = item.roundedAmount;
				this.Form.transactionData.status = item.status;
				this.Form.transactionData.transactionDate = item.transactionDate;
				this.Form.transactionData.transactionId = item.transactionId;
				this.Form.transactionData.transactionListId = item.transactionListId;
				// this.Form.transactionData.transactionNumber = item.transactionNumber;
				this.Form.transactionData.notes = item.notes;

				this.Form.productRefId = item.productId;
				this.Form.itemId = item.productId;
				this.Form.itemName = item.productName;

				this.fn_getSummary(item.productId);
				this.fn_getBatches(item.productId);

				for(let i=0; i<item.transactionProducts.length; i++){
					if(!item.transactionProducts[i].batches){
						item.transactionProducts[i].batches = [];
					}
				}

				if(item.transactionProducts.length > 1){
					let averageRateSum = 0;
					let totalQty = 0;
					for(let i=0; i<item.transactionProducts.length; i++){
						// average rate per piece
						let averageRate =  item.transactionProducts[i].variants[0].qty / item.transactionProducts[i].rate;
						// average rate per piece of all transaction products
						averageRateSum = averageRateSum + averageRate
						// total quantity
						totalQty = totalQty + Number(item.transactionProducts[i].variants[0].qty);
					}
					item.transactionProducts[0].rate = this.roundUpto2Decimals(averageRateSum * totalQty);
					item.transactionProducts[0].variants[0].rate = this.roundUpto2Decimals(averageRateSum * totalQty);
					item.transactionProducts[0].variants[0].qty = totalQty;
					let temp = JSON.parse(JSON.stringify(item.transactionProducts[0]));
					item.transactionProducts = [];
					item.transactionProducts.push(temp);
				}
				

				this.Form.trProducts = JSON.parse(JSON.stringify(item.transactionProducts));

				this.fn_bindLabels(this.Form.trProducts);

				//adding/updating default variants values
				this.fn_pushVariants(item.variants);

				let self = this;
				setTimeout(function () {
					self.$root.fn_copyFormObject(self.Form, self.formId);
					let htmlElement = document.getElementsByClassName(self.$route.query.groupId)[0];
					htmlElement ? self.$vuetify.goTo(htmlElement, self.scrollOptions) : '';
				},300);
			},

			fn_bindLabels: function (items) {
				let self = this;
				for(let i = 0; i < items.length; i++){
					for(let j = 0; j < items[i].variants.length; j++){
						(function (i, j) {
							let uName = items[i].variants[j].unitName;
							let pQty = items[i].variants[j].packQuantity;
							self.fn_getLabel(uName, pQty, function (label) {
								items[i].variants[j].label = label;
							});
						}(i, j))
					}
				}
			},

			// fn_clearForm: function(openingDate, maxOpeningDate, minDate){
			fn_clearForm: function(){
				this.Form.transactionData = JSON.parse(JSON.stringify(transactionData));
				this.Form.transactionProducts = [];
				this.Form.trProducts = [];
				// this.Form.deletedTransactionProductIds = [];
				this.Form.summary = '';
				this.Form.summaryArray = [];
				// this.Form.openingDate = openingDate ? openingDate : null
				// this.Form.maxOpeningDate = maxOpeningDate ? maxOpeningDate : null,
				// this.Form.minDate = minDate ? minDate : null,

				// this.Form.draftItems = [];
				this.$validator.reset();
			},

			// fn_saveToLocalStorage: function(){
			// 	if(!this.unwatch){
			// 		var dataObj = {};
			// 		dataObj.type = "OpeningStock";
			// 		dataObj.formType = "new";
			// 		dataObj.modifiedDate = new Date();
			// 		dataObj.formId = this.formId;
			// 		dataObj.draftId = this.draftStorageId;
			// 		dataObj.uri = this.$route.path;
			// 		dataObj.dataModel = this.Form;
			// 		localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
			// 	}
			// 	this.unwatch = false;
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				// else if(menuAction=='delete'){
				// 	this.fn_deleteItem(this.Form.transactionData.transactionId);
				// }
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
				else if(menuAction=='refreshUnits'){
					this.fn_getProductData(this.Form.itemId, true);
				}
				else if(menuAction=='addnote'){
					this.fn_addNote();
				}
			},

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#note', self.scrollOptions);
				},300);
			},

			fn_resetForm: function () {
				this.Form.itemId ? this.fn_getData('TransactionProductsOfProduct', this.Form.itemId) : ''; 
				// this.loadedFromDraft = false;
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					// self.snackbar = true;
					// self.snackbar_msg = "Item deleted from draft";
					self.showToast("Item deleted from draft");
				});
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
					    case "product":
					    	this.fn_updateProduct(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_addBatch: function(){
				this.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
			},

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerBatch');
				})
			},

			fn_updateDate: function (value) {
				this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
				this.fn_closeDialog();
			},

			fn_appendBatches: function(batches){
				if(batches.length){
					this.$set(this.Form, 'batches', JSON.parse(JSON.stringify(batches)));
					let qty = 0;
					for(let i=0; i<batches.length; i++){

						!batches[i].opening ? batches[i].opening = 0 : '';

						let batchIndex = this.Form.batches.findIndex(item=>{return item.batchId == batches[i].batchId})

						if(batchIndex != -1){
							this.Form.batches[batchIndex] = JSON.parse(JSON.stringify(batches[i]));
						}
						else{
							this.Form.batches.push(JSON.parse(JSON.stringify(batches[i])));
						}
						
						// if(!batches[i].field1 && !batches[i].field2 && !batches[i].field3){
							if(batches[i].opening){
								qty = qty + batches[i].opening;
							}
						// }
						this.Form.trProducts[0].variants[0].qty = qty;
					}
				}
				this.fn_closeDialog();
			},

			fn_removeBatch: function(batchIndex){
				this.Form.batches.splice(batchIndex, 1);
				let totalQty = 0;
				for(let i=0; i<this.Form.batches.length; i++){
					totalQty = totalQty + Number(this.Form.batches[i].opening);
				}
				this.Form.trProducts[0].variants[0].qty = totalQty;
			},

			fn_getBatches: function(productId, addedBatches){
				let self = this;
				this.getData('GetProductBatchByProductId', productId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.$set(self.Form, 'batches', JSON.parse(response));

							if(addedBatches && addedBatches.length){
								for(let i=0; i<addedBatches.length; i++){
									let bIndex = self.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
									if(bIndex == -1){
										self.Form.batches.push(addedBatches[i]);
									}
								}
							}
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_openDialogSelectBatch: function(transactionItem, index){
				// this.Form.batches = JSON.parse(JSON.stringify(batches));
				let batches = this.Form.trProducts[0].batches && this.Form.trProducts[0].batches.length ? this.Form.trProducts[0].batches : '';
				if(batches && batches.length){
					for(let i=0; i<this.Form.batches.length; i++){
						this.Form.batches[i].productQty = null;
						this.Form.batches[i].selected = false;
						for(let j=0; j<batches.length; j++){
							if(batches[j].batchId == this.Form.batches[i].batchId){
								if(batches[j].productQty){
									this.Form.batches[i].selected = true;
									this.Form.batches[i].productQty = batches[j].productQty;
								}
							}
						}
					}
				}
				this.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
			},

			// fn_checkOpening: function(){
			// 	let filterObject = {};
			// 	filterObject.transactionListId = [transactionTypes.openingStock.id, transactionTypes.openingLedger.id];

			// 	let self = this;
			// 	this.getFilterData('CheckOpening', null, filterObject, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let openingDate = JSON.parse(response);
			// 				if(!openingDate){
			// 					self.fn_getFirstTransactionDate();
			// 				}
			// 				else{
			// 					self.Form.openingDate = new Date(openingDate);
			// 				}
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			// fn_getFirstTransactionDate: function(){
			// 	let self = this;
			// 	this.getData('FirstTransactionDate', null, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let maxDate = JSON.parse(response);

			// 				if(!maxDate){
			// 					//Calculation of max date fy
			// 					let currentDate = new Date();
			// 					let currentMonth = currentDate.getMonth() + 1;
			// 					let currentYear = currentDate.getFullYear();

			// 					let year = null
			// 					year = currentMonth < 3 ? currentYear : currentYear+1;

			// 					maxDate = new Date(year+"-03-31");
			// 				}
			// 				else{
			// 					maxDate = new Date(maxDate);
			// 				}

			// 				// maxDate = !maxDate ? new Date("2020-03-31") : new Date(maxDate);

			// 				//subtracted 1 day as opening only can enter one or more day before first transaction have been made and onwards
			// 				maxDate.setDate(maxDate.getDate()-1);

			// 				console.log(maxDate);

			// 				let year = self.$moment(maxDate).format('YYYY');
			// 				let month = self.$moment(maxDate).format('MM');
			// 				let day = self.$moment(maxDate).format('DD');

			// 				self.Form.maxOpeningDate = year+"-"+month+"-"+day;
			// 				self.fn_calculateOpeningDate();
			// 	        },
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
			// },

			// fn_calculateOpeningDate: function(){
			// 	// Calculation of opening ledger date
			// 	let currentDate = new Date();
			// 	let currentMonth = currentDate.getMonth() + 1;
			// 	let currentYear = currentDate.getFullYear();

			// 	let openingLedgerYear = null
			// 	openingLedgerYear = currentMonth > 3 ? currentYear : currentYear-1;

			// 	this.Form.openingDate = new Date(openingLedgerYear+"-03-31");

			// 	let year = this.$moment(this.Form.openingDate).format('YYYY');
			// 	let month = this.$moment(this.Form.openingDate).format('MM');
			// 	let day = this.$moment(this.Form.openingDate).format('DD');

			// 	this.Form.minDate = year+"-"+month+"-"+day;
			// },

			// fn_unitChange: function(value, item, product){
			// 	let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
			// 	if(currentItemId != value.itemId){
			// 		if(value.itemId == item.secondaryUnitId){
			// 			product.rate = this.roundUpto2Decimals(product.rate / item.secondaryUnitPackQuantity);
			// 		}
			// 		else{
			// 			product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
			// 		}
			// 	}
			// },

			fn_unitChange: function(value, item, product){
				let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
				if(currentItemId != value.itemId){
					if(value.itemId == item.secondaryUnitId){
						product.rate = (product.rate * item.packQuantity) / item.secondaryUnitPackQuantity;
					}
					else{
						product.rate = (product.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
						// product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
					}
					// this.tempRate = product.rate;
					product.rate = this.roundUpto2Decimals(product.rate); 
				}
			},

			// fn_assignTempValue: function(val){
			// 	this.tempRate = val;
			// },

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				// !this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") ?  this.fn_checkTransactionCount() : '';
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ?  this.fn_checkTransactionCount() : '';
			if(!this.$root.CurrentBusiness.DataDrive){
				this.fn_checkTransactionCount(()=>{
					if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
						this.fn_openDialogDriveSetup();
					}
				})
			}

			var formsArray = [];
			if(localStorage.getItem('openingstockforms')){
				formsArray = JSON.parse(localStorage.getItem('openingstockforms'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('openingstockforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();
			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}
			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				// this.fn_setFormDataFromLocalStorage();
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('temp', "Opening Stock");

			if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}
			}

			if(!this.Form.selectedBatchType){
				this.unwatch = true;
				this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
			}

			// this.fn_checkOpening(transactionTypes.openingStock.id, transactionTypes.openingLedger.id);
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='stockItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}


		  		//checking if draft exist
		  		vm.fn_isDraft(function(isDraft){
		  			if(itemId && !isDraft){
		  				vm.fn_getData('TransactionProducts', itemId);
		  			}

		  			if(!isDraft && !itemId && !localStorage.getItem('newItem')){
		  				if(!vm.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive")){
		                    vm.fn_checkTransactionCount(function(transactionCount){
		                        if(transactionCount < 10){
		                            setTimeout(function(){
		                                vm.fn_openProductsDialog()
		                            },300);
		                        } 
		                    })  
		                }
		                // else{
		                // 	setTimeout(function(){
	                 //            vm.fn_openProductsDialog()
	                 //        },300);
		                // }
		  			}
		  			

		  			// !isDraft && !itemId && !localStorage.getItem('newItem') ? vm.fn_openProductsDialog() : '';
		  		})

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('openingstockforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true, 1);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						this.backButtonPress = false;
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					localStorage.removeItem('openingstockforms');
					localStorage.removeItem("SetDataDrive");
					next();	
				}
			}
	    },
	    computed:{
	    	totalAmount: function () {
	    		let amount = 0;

				for(let i=0;i<this.Form.trProducts.length;i++){
					let rate = 0, packQuantity = 0, qty = 0;

	    			for(let j=0;j<this.Form.trProducts[i].variants.length;j++){
	    				let variant = this.Form.trProducts[i].variants[j];

	    				//calculation of item amount
	    				this.fn_itemTotal(variant, this.Form.trProducts[i].rate);

	    				this.Form.trProducts[i].rate ?  rate = Number(this.Form.trProducts[i].rate) : '';

	    				variant.qty ? qty = Number(variant.qty) : qty = 0;

	    				if(qty){
	    					// variant.packQuantity ? packQuantity = Number(variant.packQuantity) : packQuantity = 1;
							packQuantity = 1;
	    				}
	    				else{
	    					packQuantity = 0;
	    				}

	    				amount += rate * packQuantity * qty;
	    			}
	    		}

	    		return this.roundUpto2Decimals(amount);
	    	},
			batchTotalQty: function(){
				let totalQty = 0;
				for(let i=0; i<this.Form.batches.length; i++){
					if(this.Form.batches[i].opening){
						totalQty = totalQty + Number(this.Form.batches[i].opening);
					}
				}
				return totalQty;
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/opening_stock/form.vue